module.exports = __webpack_public_path__ + "img/item-bg.e563583b.png";